export default "__VITE_ASSET__Dc3_1fWn__"